import { Card, COD, EMI, Netbanking, Paylater, UpiIcons, Wallet } from 'src/components/common/PaymentIcons'
import { PaymentMethodsUIConfigType, UIPreviewPaymentMethods } from 'src/lib/types/uiPreview'

export const paymentMethodsUIConfigs: PaymentMethodsUIConfigType[] = [
  {
    icon: UpiIcons,
    type: UIPreviewPaymentMethods.UPI,
    label: 'UPI'
  },
  {
    icon: Card,
    type: UIPreviewPaymentMethods.CARD,
    label: 'Debit/Credit Card'
  },
  {
    icon: Wallet,
    type: UIPreviewPaymentMethods.WALLET,
    label: 'Wallets'
  },
  {
    icon: Netbanking,
    type: UIPreviewPaymentMethods.NETBANKING,
    label: 'Netbanking'
  },
  {
    icon: EMI,
    type: UIPreviewPaymentMethods.EMI,
    label: 'EMI'
  },
  {
    icon: Paylater,
    type: UIPreviewPaymentMethods.PAY_LATER,
    label: 'Pay later'
  },
  {
    icon: COD,
    type: UIPreviewPaymentMethods.COD,
    label: 'Cash on delivery'
  }
]
